import React from 'react';
import { useTranslation } from 'react-i18next';
import CandidateCard from './CandidateCard';

const CandidatesMobileView = ({
  candidates,
  onTogglePriority,
  onDeleteCandidate,
  userPlan,
  isRestricted,
  selectedIds,
  onToggleSelect,
}) => {
  const { t } = useTranslation();

  if (candidates?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 text-center">
        <p className="text-muted-foreground">{t('candidates.noMatch')}</p>
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {candidates?.map((candidate) => (
        <CandidateCard
          key={candidate?.id}
          candidate={candidate}
          onTogglePriority={onTogglePriority}
          onDeleteCandidate={onDeleteCandidate}
          userPlan={userPlan}
          isRestricted={isRestricted}
          isSelected={selectedIds?.has(candidate?.id)}
          onToggleSelect={onToggleSelect}
        />
      ))}
    </div>
  );
};

export default CandidatesMobileView;
